import Link from "next/link";

interface LogoProps {
  href?: string;
  size?: number;
  className?: string;
  // When true, render a plain <a> instead of next/link (e.g. linking to the
  // separate landing subdomain). Defaults to in-app client navigation.
  external?: boolean;
}

export default function Logo({ href = "/dashboard", size = 22, className, external = false }: LogoProps) {
  const style = { fontFamily: "var(--font-lora)", fontSize: `${size}px`, fontWeight: 600, letterSpacing: "-0.02em" } as const;
  const inner = (
    <>
      <span className="text-[var(--text-primary)]">Psy</span>
      <span className="text-[var(--accent-warm)]">Practice</span>
    </>
  );
  if (external) {
    return (
      <a href={href} className={className} style={style}>
        {inner}
      </a>
    );
  }
  return (
    <Link href={href} className={className} style={style}>
      {inner}
    </Link>
  );
}
